import React from 'react';

const CatalogIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="28"
      viewBox="0 0 25 28"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.84277 0H22.8428C23.3732 0 23.8819 0.210714 24.257 0.585786C24.6321 0.960859 24.8428 1.46957 24.8428 2V26C24.8428 26.5304 24.6321 27.0391 24.257 27.4142C23.8819 27.7893 23.3732 28 22.8428 28H4.84277C4.31234 28 3.80363 27.7893 3.42856 27.4142C3.05349 27.0391 2.84277 26.5304 2.84277 26V22H0.842773V20H2.84277V15H0.842773V13H2.84277V8H0.842773V6H2.84277V2C2.84277 1.46957 3.05349 0.960859 3.42856 0.585786C3.80363 0.210714 4.31234 0 4.84277 0ZM4.84277 26H22.8428V2H4.84277V6H6.84277V8H4.84277V13H6.84277V15H4.84277V20H6.84277V22H4.84277V26ZM18.8428 6H10.8428V8H18.8428V6ZM18.8428 13H10.8428V15H18.8428V13ZM18.8428 20H10.8428V22H18.8428V20Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export default CatalogIcon;